import { TimerMarkerOutlineIcon } from './TimerMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D31E92C3-4D5C-4029-9D91-0C41DDFDB164
 * name timer-marker-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-marker-outline.svg
 * tags
 * - Date / Time 
 * - Navigation 
 */
export const TimerLocationOutlineIcon = TimerMarkerOutlineIcon;
export default TimerLocationOutlineIcon